export default __webpack_public_path__ + "static/media/lampadas.f6a55174.svg";